import { HeaderConfig } from '@/types/general';

export const gamesJurisdictionsTableHeaders: HeaderConfig[] = [
  {
    label: 'Jurisdiction',
    fixedWidth: 280,
  },
  {
    label: 'Country Code',
  },

  {
    label: 'AGG 1',
  },

  {
    label: 'AGG 2',
  },
  {
    label: 'Status',
    align: 'end',
  },
];
